import { Component, OnInit, NgZone } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { AnimationItem } from 'lottie-web';
import { ScrollService } from '../scroll.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  sidenav: any;
  phoneIco: AnimationOptions = {
    path: '../assets/animations/phoneColored.json',
  };
  hamburger: AnimationOptions = {
    path: '../assets/animations/hamburger.json',
    autoplay: false,
    loop: false
  };
  public shrink = false;
  public showSidebar = false;
  public showFiller = false;
  public animation: AnimationItem; 

  constructor(
    public scroll: ScrollService,
    private router: Router,
    private ngZone: NgZone,
  ) { }

  ngOnInit() {
    this.scroll.windowScroll$.subscribe(res  =>
      { if (res>99) {
      this.shrink = true } else {this.shrink = false;} 
      }
    )
  }

  hamburgerCreated(animationItem: AnimationItem): void {
    this.animation = animationItem;
  }

  play(): void {
    this.ngZone.runOutsideAngular(() => {
    this.animation.setSpeed(3)
    this.animation.play();
      });
  }
  playReverse() : void {
    this.animation.setSpeed(-3);
    this.animation.play();
  }


  goToContact() { // method allows pretext customization
    this.router.navigate(['/contatti']).then();
  }
  toggleSidebar() {
    if(this.showSidebar) {
      this.playReverse();
      setTimeout(() => {
        this.showSidebar = false;
    
    }, 200);
    } else {
      this.play();
      this.showSidebar = true;
    }
  

    console.log(this.showSidebar);
  }
  daje() {
    if (this.showSidebar) {
      this.playReverse();
      setTimeout(() => {
        this.showSidebar = false;
      
    }, 200);
    }
  }
}
